import { memo } from "react";
import { Link } from "wouter";
import { BadgePercent } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useTokenSavings } from "@/hooks/useTokenSavings";
import { formatCompactTokens } from "@shared/tokenSavings";

export const TokenSavingsChip = memo(function TokenSavingsChip() {
  const { data } = useTokenSavings("all");
  const saved = data?.totalSaved ?? 0;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link
          href="/token-savings"
          className="inline-flex items-center gap-1 rounded-md px-2 h-8 text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-muted/80 transition-colors"
          data-testid="token-savings-chip"
        >
          <BadgePercent className="h-3.5 w-3.5" />
          <span>Saved {formatCompactTokens(saved)}</span>
        </Link>
      </TooltipTrigger>
      <TooltipContent>
        <p>Chat: {formatCompactTokens(data?.chatSaved ?? 0)}</p>
        <p>MCP: {formatCompactTokens(data?.mcpSaved ?? 0)}</p>
        <p>Rest of app: {formatCompactTokens(data?.restSaved ?? 0)}</p>
      </TooltipContent>
    </Tooltip>
  );
});
